import * as React from 'react';
import { FC, RefObject, useState, useEffect } from 'react';
import { useLocales } from './locales';

const SEARCH_TIMEOUT = 350; // ms

const NameFilter: FC<{
  value: string | undefined;
  onChange: (v: string) => void;
  // Bumped on every reset of the filters.
  resets: number;
  inputRef: RefObject<HTMLInputElement>;
}> = ({ value, onChange, resets, inputRef }) => {
  const [name, setName] = useState(value || '');
  const [loadTimeoutId, setLoadTimeoutId] = useState<number>();
  const l = useLocales();

  const changeValue = (v: string = name) => {
    if (!v.length || v.length >= 3) {
      onChange(v);
    }
  };

  // A reset drops the typed name along with its pending search, even one not searched for yet.
  useEffect(() => {
    if (!resets) return;

    window.clearTimeout(loadTimeoutId);
    setName(value || '');
  }, [resets]);

  const debouncedSearch = (v: string) => {
    setName(v);
    window.clearTimeout(loadTimeoutId);
    setLoadTimeoutId(
      window.setTimeout(() => {
        changeValue(v);
      }, SEARCH_TIMEOUT)
    );
  };

  return (
    <label className="f-search_field">
      <input
        ref={inputRef}
        aria-label={l('search')}
        placeholder={l('search')}
        type="search"
        value={name}
        onChange={(e) => debouncedSearch(e.target.value)}
        className="f-search_input xo-button xo-button_faded xo-button_full-width"
      />
    </label>
  );
};

export default NameFilter;
